const SUBJECT_PREFIX = '{{PREFIX}}';

export default class Body {

	constructor({
		id,
		content_html: contentHtml,
		content_json: contentJson,
		lang,
		region,
		subject
	}) {
		this._id = id;
		this._contentHtml = contentHtml;
		this._contentJson = contentJson;
		this._lang = lang || null;
		this._region = region;
		this._subject = subject || "";

	}

	getKey() {
		return String(this._id);
	}

	getId() {
		return this._id;
	}

	getUnlayerDesign() {
		return this._contentJson;
	}

	getHTML() {
		return this._contentHtml || "";
	}

	getLang() {
		return this._lang;
	}

	getRegion() {
		return this._region;
	}


	getSubject() {
		// For the sample feature, we add {{PREFIX}} at the start of the
		// subject. When we display the subject to the user, this prefix
		// is hidden
		let subject = this.getRawSubject();

		// When the subject starts with the prefix, hide it
		if (subject.indexOf(SUBJECT_PREFIX) === 0) {
			subject = subject.slice(SUBJECT_PREFIX.length);
		}
		return subject;
	}

	getRawSubject() {
		// The original subject
		return this._subject;
	}
}
